import { jsx as _jsx } from "react/jsx-runtime";
export function ExternalLinkLink(param) {
    let { href, children } = param;
    return /*#__PURE__*/ _jsx("p", {
        className: "mt-4 text-brand-400 hover:cursor-pointer hover:text-brand-400 cursor-pointer hover:underline",
        children: /*#__PURE__*/ _jsx("a", {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            children: children
        })
    });
}
